export const DATA_ANALYSIS_ROOT_PERMISSION = 'ops:analysis:query'

export const DATA_ANALYSIS_CHILD_PERMS = [
  'ops:powerTrack:query',
  'ops:loadTrack:query',
  'ops:demandAnalysis:query',
  'ops:voltageConsistency:query',
  'ops:temperatureThermal:query',
  'ops:meterAnalysis:query',
]

export const DATA_ANALYSIS_MENU_PERMS = [
  DATA_ANALYSIS_ROOT_PERMISSION,
  ...DATA_ANALYSIS_CHILD_PERMS,
]

export function hasAnyPermission(userPerms = [], requiredPerms = []) {
  if (!Array.isArray(requiredPerms) || !requiredPerms.length) return true
  return (userPerms || []).some(permission => permission === '*:*:*' || requiredPerms.includes(permission))
}
